/* ---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *-------------------------------------------------------------------------------------------- */
export var conf = {
  // 注释配置
  comments: {
    blockComment: ['<#--', '-->']
  },
  // 括号
  brackets: [['<#', '>']],
  // 关键字
  keywords: [],
  // 自动关闭补全配置，例如输入<#if自动补充></#if>
  autoClosingPairs: [
    // { open: '<#', close: '>' },
    { open: '<#--', close: '-->' },
    { open: '</#', close: '>' },
    { open: "'", close: "'" },
    { open: '"', close: '"' }
  ],
  surroundingPairs: [
  ]
}
export var language = {
  defaultToken: '',
  tokenPostfix: '.ftl',
  ignoreCase: true,
  // Useful regular expressions
  qualifiedName: /(?:[\w\.\-]+:)?[\w\.\-]+/,
  tokenizer: {
    root: [
      [/[^<&$]+/, ''], // 需要被作为语法识别的字符，当去掉$符号时，变量识别不生效
      { include: '@whitespace' },
      // #标签开头
      [/(<#)(@qualifiedName)/, [{ token: 'tag' }, { token: 'tag', next: '@tag' }]],
      // #标签结尾
      [
        /(<\/#)(@qualifiedName)(\s*)(>)/,
        [{ token: 'tag' }, { token: 'tag' }, '', { token: 'tag' }]
      ],
      // @标签开头
      [/(<@)(@qualifiedName)/, [{ token: 'metatag' }, { token: 'metatag', next: '@exttag' }]],
      // @标签结尾
      [/(<\/@)((?:[\w\.\-]+:)?[\w\.\-]*)(\s*)(>)/, [{ token: 'metatag' }, { token: 'metatag' }, '', { token: 'metatag' }]],
      [/'([^']+)'/, 'string'], // 字符串
      [/'([^"]+)'/, 'string'], // 字符串
      [/&\w+;/, 'string.escape']
    ],
    tag: [
      [/[ \t\r\n]+/, ''],
      [/'([^']*)'/, 'string'], // 字符串
      [/"([^"]*)"/, 'string'], // 字符串
      [
        /(@qualifiedName)(\s*=\s*)("[^"]*"|'[^']*')/,
        ['attribute.name', '', 'attribute.value']
      ],
      [
        /(@qualifiedName)(\s*=\s*)("[^">?\/]*|'[^'>?\/]*)(?=[\?\/]\>)/,
        ['attribute.name', '', 'attribute.value']
      ],
      [
        /(@qualifiedName)(\s*=\s*)("[^">]*|'[^'>]*)/,
        ['attribute.name', '', 'attribute.value']
      ],
      [/@qualifiedName/, 'attribute.name'],
      [/(\/)(>)/, [{ token: 'tag' }, { token: 'tag', next: '@pop' }]],
      [/>/, { token: 'tag', next: '@pop' }]
    ],
    // 扩展标签
    exttag: [
      [/[ \t\r\n]+/, ''],
      [/'([^']*)'/, 'string'], // 字符串
      [/"([^"]*)"/, 'string'], // 字符串
      [
        /(@qualifiedName)(\s*=\s*)("[^"]*"|'[^']*')/,
        ['attribute.name', '', 'attribute.value']
      ],
      [
        /(@qualifiedName)(\s*=\s*)("[^">?\/]*|'[^'>?\/]*)(?=[\?\/]\>)/,
        ['attribute.name', '', 'attribute.value']
      ],
      [
        /(@qualifiedName)(\s*=\s*)("[^">]*|'[^'>]*)/,
        ['attribute.name', '', 'attribute.value']
      ],
      [/@qualifiedName/, 'attribute.name'],
      [/(\/)(>)/, [{ token: 'metatag' }, { token: 'metatag', next: '@pop' }]],
      [/>/, { token: 'metatag', next: '@pop' }]
    ],
    whitespace: [
      [/[ \t\r\n]+/, ''],
      [/<!--/, { token: 'hcomment', next: '@hcomment' }], // 如果匹配上<!--，则继续匹配comment对象中的内容
      [/<#--/, { token: 'comment', next: '@comment' }], // 如果匹配上<#--，则继续匹配hcomment对象中的内容
      [/\$\{/, { token: 'tag', next: '@variable' }], // 变量处理
      [/<#noparse>/, { token: 'tag', next: '@noparse' }] // 如果匹配上<#noparse>，则继续匹配@noparse对象中的内容，解决noparse下均为不解析的字符高亮情况
    ],
    comment: [
      [/[^<\-]+/, 'comment.content'],
      [/-->/, { token: 'comment', next: '@pop' }],
      [/<!--/, 'comment.content.invalid'], // 如果注释中又包含了注释，则视为无效注释
      [/<#--/, 'comment.content.invalid'],
      [/[<\-]/, 'comment.content']
    ],
    // <#---->注释配置
    hcomment: [
      [/[^<\-]+/, 'hcomment.content'],
      [/-->/, { token: 'hcomment', next: '@pop' }],
      [/<!--/, 'hcomment.content.invalid'], // 注释嵌套处理
      [/<#--/, 'hcomment.content.invalid'],
      [/[<\-]/, 'hcomment.content']
    ],
    // 变量
    variable: [
      [/[^\?\},\.\(\)'"]+/, 'variable'],
      [/(\?)([a-zA-Z_\.]+)/, [{ token: 'function.start' }, { token: 'function.name' }]], // 匹配函数开始符号和函数名称
      [/[,]/, 'tag'], // 匹配参数分割
      [/'([^']*)'/, 'string'], // 匹配参数值
      [/"([^"]*)"/, 'string'], // 匹配参数值
      [/[\}]/, { token: 'tag', next: '@pop' }] // 变量识别结束
    ],
    noparse: [
      [/<\/#noparse>/, { token: 'tag', next: '@pop' }]
    ]
  }
}
